const { is } = require('../../is/is')

/**
 * Visszaadja egy tömb bizonyos értékét egy index alapján.
 * @template T
 * @param {readonly T[]} list - A tömb, amiből szeretnénk egy értéket elkérni.
 * @param {number} index - Az index, hogy a tömb melyik helyiértékén keressük az értéket.
 * @returns {T | undefined} Az érték vagy undefined.
 */
function get (list, index) {
  if (is.function(Array.prototype.at)) {
    // eslint-disable-next-line no-restricted-syntax
    return list.at(index)
  }

  if (index >= 0) {
    return list[index]
  }

  return list[list.length - index]
}

module.exports.get = get
